<template>
<!-- 表格 -->
    <div class="contain-right-table">
        <div class="contain-right-table-search">
            <span>订单记录</span>
            <div class="contain-right-table-search-btn">
                <div class="filter-item-list">
                    <el-select
                        v-model="listQuery.article_category_id"
                        placeholder="产品名筛选"
                        clearable
                        style="width: 176px"
                    >
                        <el-option
                        v-for="v in category_list"
                        :label="v.name"
                        :value="v.article_category_id"
                        :key="v.id"
                        />
                    </el-select>
                    <el-select
                        v-model="listQuery.article_category_id"
                        placeholder="订单状态筛选"
                        clearable
                        style="width: 176px"
                    >
                        <el-option
                        v-for="v in category_list"
                        :label="v.name"
                        :value="v.article_category_id"
                        :key="v.id"
                        />
                    </el-select>
                    <el-date-picker
                        v-model="date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="时间筛选"
                    ></el-date-picker>
                    <div class="to">-</div>
                    <el-date-picker
                        v-model="date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="时间筛选"
                    ></el-date-picker>
                </div>
                <el-button type="primary">查询</el-button>
            </div>
        </div>
        <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        stripe
        fit
        :header-cell-style="{background:'#F9FAFD',border:'none'}"
        highlight-current-row>
        <el-table-column align="center" label="订单号"  min-width="110">
            <template slot-scope="scope">
            {{ scope.row.id }}
            </template>
        </el-table-column>
        <el-table-column label="所购套餐" min-width="110" align="center">
            <template slot-scope="scope">
            {{ scope.row.username }}
            </template>
        </el-table-column>
        <el-table-column label="金额（元）" min-width="110" align="center">
            <template slot-scope="scope">
            {{ scope.row.username }}
            </template>
        </el-table-column>
        <el-table-column label="套餐起始时间" min-width="110" align="center">
            <template slot-scope="scope">
            {{ scope.row.username }}
            </template>
        </el-table-column>
        <el-table-column label="套餐结束时间" min-width="110" align="center">
            <template slot-scope="scope">
            {{ scope.row.username }}
            </template>
        </el-table-column>
        <el-table-column label="订单创建时间" min-width="110" align="center">
            <template slot-scope="scope">
            {{ scope.row.username }}
            </template>
        </el-table-column>
        <el-table-column label="状态" min-width="110" align="center">
            <template slot-scope="scope">
            {{ scope.row.username }}
            </template>
        </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </div> 
    </div>
</template>
<script>
export default {
    data(){
        return{
            listQuery: {
                page: 1,
                limit: 10
            },
            list: null,
            total: null,
            listLoading: true,
            btnLoading: false,
            date:'',
        }
    },
}
</script>
<style lang="scss">
    .contain-right-table{
        margin-top: 20px;
        padding: 20px;
        background: #FFFFFF;
        border-radius: 8px;
        .contain-right-table-search{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            span{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #506176;
            }
            .contain-right-table-search-btn{
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                .filter-item-list{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    img{
                        width: 40px;
                        height: 40px;
                        margin-right: 20px;
                    }
                    .to{
                        margin: 0 10px;
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #CCCCCC;
                    }
                    
                }
                .el-select{
                    margin-right: 15px;
                }
                .el-button{
                    margin-left: 15px;
                }
            }
        }
        .pagination-container{
            margin-top: 60px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }
    }
</style>